import type { FormOption } from "~/types/ui";
import { ComboBox } from "./combo-box";

interface StringifySelectProps {
  options: FormOption<any>[];
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  isMulti?: boolean;
  disabled?: boolean;
  clearable?: boolean;
  className?: string;
}

export function StringifySelect({
  options,
  placeholder = "Select...",
  value,
  onChange,
  isMulti = false,
  clearable = false,
  disabled,
  className = "",
}: StringifySelectProps) {
  const settings = options.find((x) => x.label == "settings")?.value;
  const delimiter = settings?.delimiter ?? ",";

  const selectedValue: string[] = settings?.isJSON
    ? JSON.parse(value ?? "{}")
    : value?.length && value?.length > 0
      ? value?.split(delimiter)
      : [];

  function handleOnChange(value: string[]) {
    onChange?.(
      settings?.isJSON ? JSON.stringify(value) : value?.join(delimiter),
    );
  }

  return (
    <ComboBox
      options={
        (options.find((x) => x.label == "options")?.value ??
          []) as FormOption<string>[]
      }
      value={selectedValue}
      onChange={(val) =>
        handleOnChange(
          isMulti || settings?.isMulti
            ? (val as string[])
            : ([val] as string[]),
        )
      }
      className={className}
      placeholder={placeholder}
      disabled={disabled}
      clearable={clearable || settings?.isClearable}
      isMulti={isMulti || settings?.isMulti}
    />
  );
}
